import { api, apiSaml } from './base';
import { Department } from './department.api';

export interface Employee {
  id: number;
  username: string;
  display_name: string;
  email: string;
  is_superadmin: boolean;
  mobile_phone_no?: string;
  position?: string;
  number?: string;
  dingtalk_id?: string;
  departments?: Array<Array<Department>>;
  department_ids?: Array<number>;
  rel_status?: number;
  allow_login?: boolean;
}

export interface EmployeeQuery {
  name?: string;
  skip?: number;
  limit?: number;
  id?: number;
  internal?: boolean;
}

export interface PasswordForm {
  cur_password: string;
  new_password: string;
  repeat_new_password: string;
}

export interface ResetPasswordForm {
  username: string;
  new_password: string;
  repeat_new_password: string;
  code: number | null;
  email: string;
  send_code: boolean;
}

export interface LoginForm {
  username: string;
  passwd: string;
}

export interface EmployeePerm {
  name: string;
  writable: boolean;
}

export interface LoginResult {
  employee: Employee;
  perms: Array<EmployeePerm>;
  html?: string;
}

export interface PubKeyResult {
  key: string;
  timestamp: string;
}

export const employeeApis = {
  async search(query?: EmployeeQuery): Promise<Array<Employee>> {
    let queryString = '';
    if (query) {
      queryString = new URLSearchParams(query as any).toString();
    }
    const result = await api.get(`/employees?${queryString}`);
    return result.employees;
  },
  updatePassword(form: PasswordForm) {
    return api.put<void>(`/password`, form);
  },
  // login(form: LoginForm) {
  //   return api.post<LoginResult>(`/login`, form);
  // },
  loginSaml(form: LoginForm) {
    return apiSaml.post<LoginResult>(`/sso/verify`, form);
  },
  resetPassword(form: ResetPasswordForm) {
    return api.post<LoginResult>(`/password`, form);
  },
  resetPasswordByDingtalk(form: { new_password: string; code: string }) {
    return api.post<LoginResult>(`/reset/dingtalk`, form);
  },
  getEmailCode(form: ResetPasswordForm) {
    return api.post<LoginResult>(`/email_code`, form);
  },
  loginByDingtalk(code: string) {
    return api.post<LoginResult>(`/login/dingtalk`, { code: code });
  },
  logout() {
    return api.post<void>('/logout');
  },
  async getPublicKey() {
    return await api.get<PubKeyResult>('/pubkey');
  },
  loginWithCaptcha(form: LoginForm, captcha: any, loginTimes: number) {
    return api.post<LoginResult>(`/loginv2`, { ...form, aliyuncaptcha: captcha, times: loginTimes });
  }
};

export interface Qrcode {
  qrcode_id: string;
  state: string;
  expire_in: number;
}

export type QRCODE_STATUS = 'missing' | 'expired' | 'unused' | 'scanned' | 'confirmed' | 'invalid';

export const qrcodeApis = {
  getQrcodeUrl(state: string) {
    return api.get<Qrcode>(`/qrlogin/dingtalk?state=${state}`);
  },
  getQrcodeStatus(qrcode_id: string, state: string) {
    return api.get<{ status: QRCODE_STATUS; message?: string }>(
      `/qrlogin/dingtalk/status?qrcode_id=${qrcode_id}&state=${state}`
    );
  },
  scanLogin(qrcodeId: string, dingtalkCode: string) {
    return api.post<{ display_name: string }>(`/qrlogin/dingtalk/scan`, { qrcode_id: qrcodeId, code: dingtalkCode });
  },
  scanLoginConfirm(qrcode_id: string) {
    return api.post(`/qrlogin/dingtalk/confirmed`, { qrcode_id });
  }
};

export const adminType: { [key: string]: string } = {
  Authorizer: '1',
  Configurator: '2',
  Auditor: '3'
};
